import type { NewsItem } from "@/types/media";

export const newsCategories = ["影视新闻", "深度解析", "行业动态"];

export const newsList: NewsItem[] = [
  {
    id: "n-01",
    title: "《回声之井》口碑持续走高，导演谈结局为何不给标准答案",
    category: "深度解析",
    date: "2026-10-12",
    author: "本刊编辑部",
    source: "挣扎吧亚当君 · 影评组",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%2C%20empty%20director%20chair%20on%20a%20misty%20film%20set%20at%20dusk%2C%20deep%20navy%20and%20warm%20orange%20lighting%2C%20moody%20documentary%20atmosphere%2C%20film%20grain%2C%20no%20text&width=1200&height=750&seq=news-echo-interview&orientation=landscape",
    summary:
      "上映三周后，《回声之井》的讨论度不降反升。导演林暐在访谈中表示，他刻意保留了开放的结局，因为「和解比真相更难演」。",
    content: [
      "上映三周后，《回声之井》凭借扎实的剧本与克制的表演，讨论度不降反升。影片围绕一桩旧案展开，却把镜头交给沉默本身。",
      "导演林暐在接受采访时表示，他从未打算给出一个「谁是真凶」的答案：「观众想抓住一个确定的东西，但生活里大多数事情没有确定答案。我要拍的是人怎么和不确定共处。」",
      "谈及结尾那口被重新掀开的井，林暐说，那是全片唯一一个他坚持保留的意象：「井盖下面是回声，不是尸体。我想让被掩盖的往事被听见，而不是被审判。」",
      "目前影片相关话题仍在持续发酵，多个影迷社群自发整理了「时间线对照表」，也有人认为开放结局削弱了类型片的爽感。无论如何，这种争论本身，或许正是主创想看到的。",
    ],
    relatedWorkId: "m-echo",
  },
  {
    id: "n-02",
    title: "不止是历史剧：《长河落日》如何把「挣扎」拍成了群像",
    category: "深度解析",
    date: "2026-10-10",
    author: "沈叙",
    source: "挣扎吧亚当君 · 剧评组",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%2C%20river%20at%20sunset%20with%20silhouettes%20of%20ancient%20boats%2C%20deep%20blue%20and%20warm%20orange%20grading%2C%20epic%20historical%20mood%2C%20film%20grain%2C%20no%20text&width=1200&height=750&seq=news-river-review&orientation=landscape",
    summary:
      "《长河落日》播出过半，观众发现真正动人的不是朝堂争斗，而是每一个小人物在洪流中不肯低头的瞬间。",
    content: [
      "很多人冲着「权谋」来，最后却被配角的命运留住。《长河落日》最难得的地方，是它没有把主角写成完人。",
      "傅珩会犹豫、会妥协、也会在深夜里后悔。正因如此，他最后那句「我守住了自己」才显得有重量。",
      "剧集用大量篇幅描写普通百姓：河工、私塾先生、边关小卒。他们的名字甚至不会被记住，但他们的挣扎构成了整条长河。",
      "有观众评价：这部剧没有爽点，却有后劲。看完之后，你会想给很久没联系的人打个电话。",
    ],
    relatedWorkId: "t-river",
  },
  {
    id: "n-03",
    title: "《雾林迷案》定档：本格推理回归，24 集不注水",
    category: "影视新闻",
    date: "2026-10-08",
    author: "影视快讯",
    source: "挣扎吧亚当君 · 资讯台",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%2C%20foggy%20pine%20forest%20at%20dawn%20with%20a%20faint%20warm%20light%20beam%2C%20deep%20blue%20mist%2C%20tense%20mysterious%20mood%2C%20film%20grain%2C%20no%20text&width=1200&height=750&seq=news-forest-premiere&orientation=landscape",
    summary:
      "主打「证据链闭环」的悬疑剧《雾林迷案》正式定档，主创承诺全剧 24 集，一个案件讲到底，不靠感情线拖时长。",
    content: [
      "《雾林迷案》正式宣布定档，并发布了首支正式预告。预告中，大雾封山、五人证词互相矛盾，氛围感拉满。",
      "制片方在采访中强调，本剧采用「证据链闭环」的写法，每一条线索都会在结局得到解释，「不会为了反转而反转」。",
      "值得一提的是，全剧只有 24 集，主创坦言这是刻意的：「悬疑剧最怕注水，我们宁可少一点，也要紧一点。」",
      "该剧将于近期上线，本刊将持续跟踪报道。",
    ],
    relatedWorkId: "t-forest",
  },
  {
    id: "n-04",
    title: "科幻剧集迎来爆发期：从《候鸟计划》到《星尘列车》",
    category: "行业动态",
    date: "2026-10-06",
    author: "何川",
    source: "挣扎吧亚当君 · 行业观察",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%2C%20vast%20starry%20night%20sky%20over%20a%20dark%20desert%20with%20a%20faint%20orange%20horizon%20glow%2C%20deep%20blue%20tones%2C%20awe%20inspiring%20atmosphere%2C%20film%20grain%2C%20no%20text&width=1200&height=750&seq=news-scifi-trend&orientation=landscape",
    summary:
      "近两年，国产科幻影视从「尝鲜」走向「常态」。观众口味的变化，正在倒逼创作者把科幻当成思考工具，而非特效秀场。",
    content: [
      "曾几何时，科幻是国产影视的稀缺品，如今它正变成一种常规类型。从《候鸟计划》到《星尘列车》，科幻作品在数量和质量上都在提升。",
      "业内人士指出，最大的变化不在特效，而在「问题意识」：越来越多的作品愿意用科幻设定去追问现实议题。",
      "当然，问题也存在。部分作品设定宏大，人物却单薄，被观众戏称为「PPT 科幻」。如何让想象力落地，仍是共同课题。",
      "可以预见的是，未来几年，科幻仍将是各大平台的必争之地。",
    ],
    relatedWorkId: "t-star",
  },
  {
    id: "n-05",
    title: "《边境来信》修复版重映，四十年后的信终于被读到",
    category: "影视新闻",
    date: "2026-10-03",
    author: "影视快讯",
    source: "挣扎吧亚当君 · 资讯台",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%2C%20snowy%20mountain%20outpost%20at%20blue%20hour%20with%20warm%20lamplight%20in%20a%20watchtower%2C%20deep%20blue%20cold%20landscape%2C%20solemn%20epic%20mood%2C%20film%20grain%2C%20no%20text&width=1200&height=750&seq=news-border-reissue&orientation=landscape",
    summary:
      "经典战争剧情片《边境来信》推出修复重映版，新增了当年删减的 11 分钟戏份，讲述那些「没被寄出的名字」。",
    content: [
      "《边境来信》修复重映版正式与观众见面，影片在原有基础上新增了 11 分钟删减片段。",
      "新片段主要集中在石堆铁盒一段，让「二十七个名字」的线索更加完整，也让结尾的投递更具冲击力。",
      "导演陈望舒表示，当年因为时长原因做了取舍，如今有机会补全，「算是给那些名字一个交代」。",
      "重映首周场次售罄，不少观众表示，第二次观看时哭得更厉害。",
    ],
    relatedWorkId: "m-border",
  },
  {
    id: "n-06",
    title: "从《不夜城手记》看都市剧的新写法：不谈恋爱，先谈生存",
    category: "深度解析",
    date: "2026-09-29",
    author: "苏晚",
    source: "挣扎吧亚当君 · 剧评组",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%2C%20rainy%20city%20street%20at%20night%20with%20warm%20orange%20shop%20lights%2C%20deep%20blue%20reflections%20on%20wet%20pavement%2C%20urban%20loneliness%20mood%2C%20film%20grain%2C%20no%20text&width=1200&height=750&seq=news-city-review&orientation=landscape",
    summary:
      "《不夜城手记》用四段交错的夜生活，替代了传统都市剧的三角恋。它更关心的，是年轻人如何在一座城市里「留下来」。",
    content: [
      "都市剧常被诟病悬浮，但《不夜城手记》选择了一个更朴素的切口：加班、房租、便利店、凌晨四点的电话。",
      "剧中几乎没有狗血桥段，最大的冲突来自现实：升职要不要放弃感情，离开是不是一种失败。",
      "有评论认为，该剧真正的主角是「城市」本身——它给了所有人机会，也逼所有人做出取舍。",
      "如果你也曾在一座陌生城市的深夜里迷路，这部剧或许会让你觉得，有人懂。",
    ],
    relatedWorkId: "t-city",
  },
  {
    id: "n-07",
    title: "《深夜食堂夜话》被票选为「最治愈下饭剧」，主创回应",
    category: "影视新闻",
    date: "2026-09-26",
    author: "影视快讯",
    source: "挣扎吧亚当君 · 资讯台",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%2C%20cozy%20late%20night%20eatery%20with%20warm%20orange%20lanterns%20and%20steaming%20dishes%2C%20deep%20blue%20street%20outside%20the%20window%2C%20intimate%20comforting%20mood%2C%20film%20grain%2C%20no%20text&width=1200&height=750&seq=news-kitchen-award&orientation=landscape",
    summary:
      "在一项观众票选中，《深夜食堂夜话》以一票之差登顶「最治愈下饭剧」。主创笑称：「我们只是想让大家好好吃饭。」",
    content: [
      "由观众投票产生的「最治愈下饭剧」榜单出炉，《深夜食堂夜话》登顶，第二名是《不夜城手记》。",
      "该剧每集围绕一道菜和一位客人展开，没有强情节，却凭真实的烟火气打动观众。",
      "主创团队在回应中表示：「我们没想教育谁，只是想让大家在深夜好好吃一顿饭，然后睡个好觉。」",
      "不少观众留言，看完一集就想给自己煮碗面——大概这就是最好的评价。",
    ],
    relatedWorkId: "t-kitchen",
  },
  {
    id: "n-08",
    title: "行业观察：为什么「剧情导航」正在成为观众的新刚需",
    category: "行业动态",
    date: "2026-09-22",
    author: "何川",
    source: "挣扎吧亚当君 · 行业观察",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%2C%20rows%20of%20cinema%20seats%20in%20deep%20blue%20darkness%20with%20a%20single%20warm%20orange%20projector%20beam%2C%20contemplative%20mood%2C%20film%20grain%2C%20no%20text&width=1200&height=750&seq=news-navigation-trend&orientation=landscape",
    summary:
      "当剧集越来越长、信息越来越密，观众需要的不再是剧透，而是「可折叠的剧情地图」——这正是本站一直在做的事。",
    content: [
      "一个明显的趋势是：观众正在主动寻找「剧情导航」，而不是被动等待剧透。",
      "所谓剧情导航，是把庞杂的情节拆成可折叠的章节，让读者按需展开。它既保留悬念，又帮助理解。",
      "在信息过载的时代，好的导航本身就是一种服务。这也是「挣扎吧亚当君」坚持为每部作品整理剧情章节的原因。",
      "未来，我们计划进一步打通作品、资讯与搜索，让每一位用户都能用最短的路径，找到最适合自己的那一部。",
    ],
  },
];